import React, { useEffect, useState } from 'react';
import { Table, Container } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import questionActions from '../../../redux/question/question.action';
import standardActions from '../../../redux/standard/standard.action';
import { selectStandardCode } from './../../../redux/question/question.select';
import Pagination from '../../Common/pagination/pagination.component';
import Layout from '../../ui/layout/layout.component';
import './admin-reports.styles.css';

const AdminReports = () => {
    const dispatch = useDispatch();
    const standards = useSelector(selectStandardCode);
    const filteredStandards = useSelector(state => state.standard.standardCode);
    const [uniqueSets, setUniqueSets] = useState([]);
    const [selectedSet, setSelectedSet] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const paginate = pageNumber => setCurrentPage(pageNumber);

    useEffect(() => {
        dispatch(questionActions.getStandardCode());
    }, [dispatch]);

    useEffect(() => {
        if (standards && standards.length > 0) {
            const sets = [...new Set(standards.map(item => item.standard_set))];
            setUniqueSets(sets);

            const savedSet = localStorage.getItem('selectedSet');
            if (savedSet) {
                setSelectedSet(savedSet);
            }
        }
    }, [standards]);

    useEffect(() => {
        if (selectedSet) {
            const queryString = `?standard_set=${selectedSet}&limit=15&offset=${(currentPage - 1) * 15}&ordering=standard_code`;
            dispatch(standardActions.getStandardCodeWithPagination(queryString));
        }
    }, [selectedSet, dispatch, currentPage]);

    const handleSelectChange = e => {
        setCurrentPage(1);
        setSelectedSet(e.target.value);
        localStorage.setItem('selectedSet', e.target.value);
    };

    return (
        <Container>
            <Layout>
                <button type="button" onClick={() => window.history.back()}>Return</button>
                <h1>Standards and Number of Questions</h1>

                <div className="standard-select">
                    <label>Standards Set</label>
                    <select value={selectedSet} onChange={handleSelectChange}>
                        <option value="">-- Select a Set --</option>
                        {uniqueSets.map((set, idx) => (
                            <option key={idx} value={set}>
                                {set}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ marginBottom: '40px' }}>
                    <Table bordered className="border-top-0 border-left-0 border-right-0">
                        <thead>
                            <tr>
                                <th
                                    className="border-0 font-style thead"
                                    style={{
                                        fontSize: '14px',
                                        color: 'black',
                                        fontWeight: 'bold',
                                        border: 0,
                                        textAlign: 'center'
                                    }}
                                >
                                    Grade
                                </th>
                                <th
                                    className="border-0 font-style thead"
                                    style={{
                                        fontSize: '14px',
                                        color: 'black',
                                        fontWeight: 'bold',
                                        border: 0,
                                        textAlign: 'center'
                                    }}
                                >
                                    Standard Set
                                </th>
                                <th
                                    className="border-0 font-style thead"
                                    style={{
                                        fontSize: '14px',
                                        color: 'black',
                                        fontWeight: 'bold',
                                        border: 0,
                                        textAlign: 'center'
                                    }}
                                >
                                    Standard Code
                                </th>
                                <th
                                    className="border-0 font-style thead"
                                    style={{
                                        fontSize: '14px',
                                        color: 'black',
                                        fontWeight: 'bold',
                                        border: 0,
                                        textAlign: 'center'
                                    }}
                                >
                                    Number of Questions
                                </th>
                                <th
                                    className="border-0 font-style thead"
                                    style={{
                                        fontSize: '14px',
                                        color: 'black',
                                        fontWeight: 'bold',
                                        border: 0,
                                        textAlign: 'center'
                                    }}
                                >
                                    Brief
                                </th>
                                <th
                                    className="border-0 font-style thead"
                                    style={{ fontSize: '14px', color: 'black', fontWeight: 'bold', border: 0 }}
                                >
                                    Complete
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedSet &&
                            filteredStandards &&
                            Array.isArray(filteredStandards.results) &&
                            filteredStandards.results.length > 0 ? (
                                filteredStandards.results.map(std => (
                                    <tr key={std.id}>
                                        <td style={{ border: 0 }}>{std.grade}</td>
                                        <td style={{ border: 0 }}>{std.standard_set}</td>
                                        <td style={{ border: 0 }}>{std.standard_code}</td>
                                        <td style={{ border: 0 }}>{std.question_count}</td>
                                        <td style={{ border: 0 }}>{std.brief}</td>
                                        <td style={{ border: 0 }}>{std.complete}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center">
                                        {selectedSet ? 'No data available' : 'Please select a standard set'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    <Pagination
                        perPage={15}
                        total={selectedSet && filteredStandards ? filteredStandards.count : 0}
                        paginate={paginate}
                        currentPage={currentPage}
                    />
                </div>
            </Layout>
        </Container>
    );
};

export default AdminReports;
